import createAccountApi from '@rhg/libs/api/create-account-api';
import useAuth from '@rhg/libs/auth0/use-auth';
import { queryKeys, useQuery } from '@rhg/libs/react-query';
import { getRhgAppHeader } from '@rhg/utils/browser';

export const TOS_CONSENT_ID = 1;

const hasAgreedToItem = (val?: number, minVersion = 0): boolean | undefined => {
    if (val === undefined) return;
    return (
        typeof val === 'number' && (minVersion ? val >= minVersion : val > 0)
    );
};

// Does not use cohort
export const useHasAcceptedCohortTos = (cohort?: string) => {
    const rHGApp = getRhgAppHeader();
    const { isAuthenticated, getAccessTokenSilently, user } = useAuth();
    const { data, ...otherProps } = useQuery({
        queryKey: [queryKeys.tosCohortConsent, cohort],
        queryFn: async () => {
            const api = createAccountApi(getAccessTokenSilently);
            const consents = await api.getConsentsV1({
                rHGApp,
                cohort,
            });
            const consentResponses = await Promise.all(
                consents.data.map(async (consent) => ({
                    consentData: consent,
                    userResponse: (
                        await api.getUserConsentByIdV1({
                            consentId: consent.consentId,
                            rHGApp,
                            userId: user!.sub!,
                        })
                    ).data,
                }))
            );

            // There should always only be one
            return consentResponses[0];
        },
        enabled: isAuthenticated && !!user,
        staleTime: 1000 * 60 * 60 * 8, // 8 hours
    });

    return {
        consent: data,
        hasAcceptedTos: !!(
            hasAgreedToItem(
                data?.userResponse?.tosVersion,
                data?.consentData?.minTosVersion
            ) &&
            hasAgreedToItem(
                data?.userResponse?.privacyVersion,
                data?.consentData?.minPrivacyVersion
            )
        ),
        ...otherProps,
    };
};

export default useHasAcceptedCohortTos;
